/**
 * Wraps a single plan card and its full-screen detail dialog.
 *
 * Uses the native <dialog> element so focus trapping, inertness of the page
 * behind it, and Escape-to-close all come from the platform rather than being
 * reimplemented here.
 */
class PlanDialog extends HTMLElement {
  /** @type {HTMLDialogElement | null} */
  #dialog = null;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');

    if (!this.#dialog) return;

    this.addEventListener('click', this.#handleClick);
    this.#dialog.addEventListener('click', this.#handleDialogClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    this.#dialog?.removeEventListener('click', this.#handleDialogClick);
  }

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    if (target.closest('[data-plan-close]')) {
      this.#dialog?.close();
      return;
    }

    if (target.closest('[data-plan-open]')) {
      this.#dialog?.showModal();
    }
  };

  /**
   * A click landing on the dialog element itself (rather than any of its
   * children) is a click on the backdrop, so dismiss.
   *
   * @param {MouseEvent} event
   */
  #handleDialogClick = (event) => {
    if (event.target === this.#dialog) this.#dialog.close();
  };
}

if (!customElements.get('plan-dialog')) {
  customElements.define('plan-dialog', PlanDialog);
}
